module.exports = __webpack_public_path__ + "img/443a3c7.png";